import type { Dict } from "../../../../shared/i18n";

/** Переводы: русский исходник → [литовский, английский] */
export default {
  // общие кнопки и поля
  "Отмена": ["Atšaukti", "Cancel"],
  "Сохранить": ["Išsaugoti", "Save"],
  "Удалить": ["Ištrinti", "Delete"],
  "Добавить": ["Pridėti", "Add"],
  "Открыть": ["Atidaryti", "Open"],
  "Убрать": ["Pašalinti", "Remove"],
  "Вернуть": ["Anuliuoti", "Undo"],
  "Название": ["Pavadinimas", "Name"],
  "Описание": ["Aprašymas", "Description"],
  "Статус": ["Būsena", "Status"],
  "Место": ["Vieta", "Place"],
  "День": ["Diena", "Day"],
  "В плане": ["Plane", "In plan"],
  "Ночёвка: {name}": ["Nakvynė: {name}", "Stay: {name}"],

  // plan/ItemEditor.tsx
  "Добавьте название": ["Įrašykite pavadinimą", "Add a name"],
  "У нового места нет координат — уточните описание или добавьте место на карте": [
    "Naujoji vieta neturi koordinačių — patikslinkite aprašymą arba pridėkite vietą žemėlapyje",
    "The new place has no coordinates — refine the description or add the place on the map",
  ],
  "Пункт удалён": ["Punktas ištrintas", "Item deleted"],
  "Пункт плана": ["Plano punktas", "Plan item"],
  "Новый пункт плана": ["Naujas plano punktas", "New plan item"],
  "Где ночуем (жильё или город)": ["Kur nakvojame (būstas ar miestas)", "Where we stay (accommodation or city)"],
  "{name} — новое место, появится на карте": ["{name} — nauja vieta, atsiras žemėlapyje", "{name} — new place, will appear on the map"],
  "координаты не найдены": ["koordinatės nerastos", "coordinates not found"],
  "Откуда": ["Iš kur", "From"],
  "Откуда…": ["Iš kur…", "From…"],
  "Куда": ["Į kur", "To"],
  "Куда…": ["Į kur…", "To…"],
  "Отправление ({tz})": ["Išvykimas ({tz})", "Departure ({tz})"],
  "Прибытие ({tz})": ["Atvykimas ({tz})", "Arrival ({tz})"],
  "Пояс отправления": ["Išvykimo laiko juosta", "Departure time zone"],
  "Пояс прибытия": ["Atvykimo laiko juosta", "Arrival time zone"],
  "Перевозчик / рейс": ["Vežėjas / reisas", "Carrier / flight no."],
  "напр. Vietjet VJ123, автобус Bao Yen": ["pvz., Vietjet VJ123, autobusas Bao Yen", "e.g. Vietjet VJ123, Bao Yen bus"],
  "Текст заметки": ["Pastabos tekstas", "Note text"],
  "Что делаем": ["Ką veikiame", "What we're doing"],
  "Начало": ["Pradžia", "Start"],
  "Конец": ["Pabaiga", "End"],
  "Ночей": ["Naktų", "Nights"],
  "Длится, мин": ["Trukmė, min.", "Duration, min"],
  "Заметки": ["Pastabos", "Notes"],
  "Детали, советы, что взять": ["Detalės, patarimai, ką pasiimti", "Details, tips, what to bring"],
  "Бронь, деньги, контакты": ["Rezervacija, pinigai, kontaktai", "Booking, money, contacts"],
  "Стоимость": ["Kaina", "Cost"],
  "Номер брони": ["Rezervacijos numeris", "Booking number"],
  "Ссылка на бронь": ["Rezervacijos nuoroda", "Booking link"],
  "Контакт (телефон, WhatsApp)": ["Kontaktas (telefonas, WhatsApp)", "Contact (phone, WhatsApp)"],
  "Кто участвует (пусто — вся группа)": ["Kas dalyvauja (tuščia — visa grupė)", "Who's taking part (empty — whole group)"],

  // plan/PlanPanel.tsx
  "приб. {time}": ["atv. {time}", "arr. {time}"],
  "{n} ночь|{n} ночи|{n} ночей": ["{n} naktis|{n} naktys|{n} naktų", "{n} night|{n} nights"],
  "Перетащить": ["Vilkti", "Drag"],
  "Прибытие {time} — {title}": ["Atvykimas {time} — {title}", "Arrival {time} — {title}"],
  "{title} (ночь {n} из {total})": ["{title} (naktis {n} iš {total})", "{title} (night {n} of {total})"],
  "Добавить в день": ["Pridėti į dieną", "Add to day"],
  "Пока пусто": ["Kol kas tuščia", "Nothing yet"],
  "План пока пуст": ["Planas kol kas tuščias", "The plan is empty"],
  "Найдите место через поиск на карте, вставьте ссылку на YouTube во вкладке «Материалы» или попросите ИИ набросать маршрут.": [
    "Raskite vietą žemėlapio paieškoje, įklijuokite YouTube nuorodą skiltyje „Šaltiniai“ arba paprašykite DI apmesti maršrutą.",
    "Find a place with map search, paste a YouTube link in the “Sources” tab or ask the AI to sketch a route.",
  ],
  "Добавить в план — словами или ссылкой": ["Pridėti į planą — savais žodžiais arba nuoroda", "Add to plan — in your own words or a link"],
  "Вне дат поездки: {n}": ["Už kelionės datų ribų: {n}", "Outside trip dates: {n}"],

  // plan/PlaceSelect.tsx
  "Найти место в поездке…": ["Ieškoti vietos kelionėje…", "Find a place in the trip…"],
  "— без места —": ["— be vietos —", "— no place —"],
  "Ничего не найдено. Добавьте место через поиск на карте.": ["Nieko nerasta. Pridėkite vietą per žemėlapio paiešką.", "Nothing found. Add a place via map search."],

  // places/PlaceDetails.tsx
  "Участник": ["Dalyvis", "Member"],
  "удалить": ["ištrinti", "delete"],
  "Написать комментарий…": ["Rašyti komentarą…", "Write a comment…"],
  "Отправить": ["Siųsti", "Send"],
  "Добавлено в {day}": ["Pridėta į planą: {day}", "Added to {day}"],
  "Скопировано": ["Nukopijuota", "Copied"],
  "Назад": ["Atgal", "Back"],
  "хотят сюда": ["nori čia nuvykti", "want to go here"],
  "Маршрут": ["Maršrutas", "Directions"],
  "Координаты": ["Koordinatės", "Coordinates"],
  "Показать водителю (крупно)": ["Parodyti vairuotojui (dideliu šriftu)", "Show to driver (large text)"],
  "Ещё не в плане.": ["Dar ne plane.", "Not in the plan yet."],
  "Добавить в день…": ["Pridėti į dieną…", "Add to day…"],
  "В план": ["Į planą", "Add to plan"],
  "Добавить описание…": ["Pridėti aprašymą…", "Add a description…"],
  "Наши заметки": ["Mūsų pastabos", "Our notes"],
  "Цены, часы, что заказать, советы друзей…": ["Kainos, darbo laikas, ką užsisakyti, draugų patarimai…", "Prices, opening hours, what to order, tips from friends…"],
  "Откуда узнали": ["Iš kur sužinojome", "Where we heard about it"],
  "Исследования ИИ": ["DI tyrimai", "AI research"],
  "Обсуждение": ["Aptarimas", "Discussion"],
  "Детали": ["Informacija", "Details"],
  "Регион": ["Regionas", "Region"],
  "Сайт / ссылка": ["Svetainė / nuoroda", "Website / link"],
  "Открыть ссылку": ["Atidaryti nuorodą", "Open link"],
  "Расскажи про «{name}» {ref}: стоит ли включать в план, когда лучше идти и что рядом?": [
    "Papasakok apie „{name}“ {ref}: ar verta įtraukti į planą, kada geriausia eiti ir kas yra netoliese?",
    "Tell me about “{name}” {ref}: is it worth adding to the plan, when is the best time to go and what's nearby?",
  ],
  "Спросить ИИ": ["Paklausti DI", "Ask AI"],
  "«{name}» удалено": ["„{name}“ ištrinta", "“{name}” deleted"],
  "Удалить место": ["Ištrinti vietą", "Delete place"],
  "Для водителя": ["Vairuotojui", "For the driver"],

  // places/AddPlaceDialog.tsx
  "координаты из ссылки": ["koordinatės iš nuorodos", "coordinates from the link"],
  "координаты со страницы": ["koordinatės iš puslapio", "coordinates from the page"],
  "найдено на карте по названию": ["rasta žemėlapyje pagal pavadinimą", "found on the map by name"],
  "координаты примерные — проверьте": ["koordinatės apytikslės — patikrinkite", "approximate coordinates — please check"],
  "Введите название": ["Įveskite pavadinimą", "Enter a name"],
  "Нет координат: уточните через ✨ или поставьте точку на карте": [
    "Nėra koordinačių: patikslinkite per ✨ arba pažymėkite tašką žemėlapyje",
    "No coordinates: refine with ✨ or drop a pin on the map",
  ],
  "«{name}» на карте": ["„{name}“ jau žemėlapyje", "“{name}” is on the map"],
  "Новое место": ["Nauja vieta", "New place"],
  "Это место уже есть в поездке: {name}": ["Ši vieta jau yra kelionėje: {name}", "This place is already in the trip: {name}"],
  "Ищу адрес…": ["Ieškoma adreso…", "Looking up the address…"],
  "Точка не задана — опишите место выше или нажмите на карту": [
    "Taškas nepažymėtas — aprašykite vietą aukščiau arba spustelėkite žemėlapį",
    "No pin yet — describe the place above or click the map",
  ],
  "Например, Phở Gia Truyền": ["Pavyzdžiui, Phở Gia Truyền", "E.g. Phở Gia Truyền"],
  "Местное название": ["Vietinis pavadinimas", "Local name"],
  "Категория": ["Kategorija", "Category"],
  "Сразу в план": ["Iš karto į planą", "Add to plan"],
  "— не добавлять —": ["— nepridėti —", "— don't add —"],
  "Регион / город": ["Regionas / miestas", "Region / city"],
  "Чем интересно, кто посоветовал": ["Kuo įdomi, kas rekomendavo", "Why it's interesting, who recommended it"],
  "Ссылка": ["Nuoroda", "Link"],
  "Телефон": ["Telefonas", "Phone"],

  // places/PlacesPanel.tsx
  "Без региона": ["Be regiono", "No region"],
  "Новое место — словами или ссылкой": ["Nauja vieta — savais žodžiais arba nuoroda", "New place — in your own words or a link"],
  "Поиск среди {n} места|Поиск среди {n} мест|Поиск среди {n} мест": [
    "Paieška tarp {n} vietos|Paieška tarp {n} vietų|Paieška tarp {n} vietų",
    "Search {n} place|Search {n} places",
  ],
  "Все": ["Visos", "All"],
  "Идеи": ["Idėjos", "Ideas"],
  "Обсуждаемые": ["Aptariamos", "Discussed"],
  "Ничего не найдено": ["Nieko nerasta", "Nothing found"],
  "Поменяйте фильтры или добавьте место через поиск на карте.": [
    "Pakeiskite filtrus arba pridėkite vietą per žemėlapio paiešką.",
    "Change the filters or add a place via map search.",
  ],

  // SmartFill.tsx
  "кафе с яичным кофе в Старом квартале Ханоя": ["kavinė su kiaušinių kava Hanojaus senamiestyje", "café with egg coffee in Hanoi's Old Quarter"],
  "ссылка из Google Maps": ["nuoroda iš Google Maps", "a Google Maps link"],
  "ссылка на отель или статью": ["nuoroda į viešbutį ar straipsnį", "a link to a hotel or article"],
  "ужин в Pho Thin 8 апреля в 19:00": ["vakarienė Pho Thin balandžio 8 d. 19:00", "dinner at Pho Thin on 8 April at 19:00"],
  "ночной автобус Ханой → Сапа 13.04 в 21:00, бронь ABC123, 450 000 ₫": [
    "naktinis autobusas Hanojus → Sapa 04-13 21:00, rezervacija ABC123, 450 000 ₫",
    "sleeper bus Hanoi → Sa Pa 13/04 at 21:00, booking ABC123, 450,000 ₫",
  ],
  "3 ночи в Хойане с 20 апреля, отель Little Riverside": ["3 naktys Hoi Ane nuo balandžio 20 d., viešbutis Little Riverside", "3 nights in Hoi An from 20 April, Little Riverside hotel"],
  "Своими словами или ссылкой": ["Savais žodžiais arba nuoroda", "In your own words or a link"],
  "Например: {example}": ["Pavyzdžiui: {example}", "For example: {example}"],
  "Разбираю…": ["Apdorojama…", "Processing…"],
  "Заполнить": ["Užpildyti", "Fill in"],
  "или: {examples}. ИИ заполнит поля ниже — проверьте и сохраните.": [
    "arba: {examples}. DI užpildys laukus žemiau — patikrinkite ir išsaugokite.",
    "or: {examples}. AI will fill in the fields below — check and save.",
  ],
} satisfies Dict;
